import { useState } from 'react';
import { safeParseConfig } from '../blockConfig';
import MediaUploader from '../../../components/MediaUploader';

const DEFAULT = { url: '', alt: '', caption: '' };

// image/audio/video all share this editor. Real upload/record (MediaUploader,
// shared with courses/topicBlockEditors.jsx's own Media editor) alongside
// the original pasted-URL field, which stays as a fallback for linking an
// external asset instead of uploading one. `block.type` already IS the
// kind here (unlike Topic's single generic "media" type), so it's passed
// straight through to MediaUploader. `courseId` is only available when
// this Builder was opened from a Topic's "attach/create exercise" flow
// (threaded down from Builder.jsx, which derives it from the returnTo
// state) - MediaUploader shows its own explanatory line in its place
// otherwise, this editor doesn't need a separate fallback branch for that.
export default function MediaBlockEditor({ block, courseId, onSave, onCancel }) {
   const initial = safeParseConfig(block.config, DEFAULT);
   const [url, setUrl] = useState(initial.url || '');
   const [alt, setAlt] = useState(initial.alt || '');
   const [caption, setCaption] = useState(initial.caption || '');
   const isImage = block.type === 'image';
   const uploaderKind = ['image', 'audio', 'video'].includes(block.type) ? block.type : null;

   const handleSave = () => {
      const cfg = isImage ? { url, alt, caption } : { url, caption };
      onSave({ config: JSON.stringify(cfg) });
   };

   return (
      <div className='exercise-block-media-editor'>
         <MediaUploader courseId={courseId} kind={uploaderKind} onUploaded={(uploadedUrl) => setUrl(uploadedUrl)} />
         <div className='exercise-block-or-divider'><span>або вставте посилання</span></div>
         <div className='exercise-block-field'>
            <label className='exercise-block-field-label'>URL файлу</label>
            <input className='exercise-block-generic-text' value={url} placeholder='https://...' onChange={e => setUrl(e.target.value)} />
         </div>
         {isImage ? (
            <div className='exercise-block-field'>
               <label className='exercise-block-field-label'>Опис зображення (alt)</label>
               <input className='exercise-block-generic-text' value={alt} placeholder='Необовʼязково' onChange={e => setAlt(e.target.value)} />
            </div>
         ) : ''}
         <div className='exercise-block-field'>
            <label className='exercise-block-field-label'>Підпис</label>
            <input className='exercise-block-generic-text' value={caption} placeholder='Необовʼязково' onChange={e => setCaption(e.target.value)} />
         </div>
         <div className='exercise-block-editor-actions'>
            <button type='button' className='exercise-block-save-btn' onClick={handleSave}>Зберегти</button>
            <button type='button' className='exercise-block-cancel-btn' onClick={onCancel}>Скасувати</button>
         </div>
      </div>
   );
}

export function renderMediaPreview(block) {
   const cfg = safeParseConfig(block.config, DEFAULT);
   if(!cfg.url) return <span className='exercise-block-empty-hint'>Порожньо</span>;
   let media;
   if(block.type === 'image') media = <img className='exercise-block-media-image' src={cfg.url} alt={cfg.alt || ''} />;
   else if(block.type === 'audio') media = <audio className='exercise-block-media-audio' src={cfg.url} controls />;
   else media = <video className='exercise-block-media-video' src={cfg.url} controls />;
   return (
      <div className='exercise-block-media-preview'>
         {cfg.caption ? <p className='exercise-block-media-caption'>{cfg.caption}</p> : ''}
         {media}
         
      </div>
   );
}
